import { JsonRpcSigner } from "ethers";
import { JsonRpcProvider } from "ethers";

import { BridgeAssist__factory, Factory__factory, Token__factory } from "./types";

export function anyBridgeAssist(address: string, signer?: JsonRpcSigner, provider?: JsonRpcProvider) {
  if (provider === undefined && signer === undefined) throw new Error("No provider passed");
  return BridgeAssist__factory.connect(address, signer ? signer : provider);
}

export function anyToken(address: string, signer?: JsonRpcSigner, provider?: JsonRpcProvider) {
  if (provider === undefined && signer === undefined) throw new Error("No provider passed");

  return Token__factory.connect(address, signer ? signer : provider);
}

export function anyFactory(address: string, signer?: JsonRpcSigner, provider?: JsonRpcProvider) {
  if (provider === undefined && signer === undefined) throw new Error("No provider passed");

  return Factory__factory.connect(address, signer ? signer : provider);
}

export function getProvider(rpc: string) {
  return new JsonRpcProvider(rpc);
}
